<div class="sidebar" [class.expanded]="sidebarExpanded">
  <!-- Logo -->
  <div *ngIf="!sidebarExpanded" class="logo-container">
      <img src="assets/AivorLogo.png" alt="Logo" class="logo">
  </div>

  <div class="logo-container">

    <div class="d-flex align-items-center" *ngIf="sidebarExpanded">
      <img src="assets/AivorLogo.png" alt="Logo" class="logo">
      <span *ngIf="sidebarExpanded" class="logo-text ms-2">AIVOR</span>
    </div>

    <!-- Toggle button -->
    <div class="toggle-button" (click)="toggleSidebar()">
      <svg *ngIf="!sidebarExpanded" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-right-circle" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"/>
      </svg>
      <svg *ngIf="sidebarExpanded" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"/>
      </svg>
    </div>
  </div>



  <div class="section-label" *ngIf="sidebarExpanded"></div>

  <ul class="nav nav-pills nav-flush flex-column mb-auto">

    <li class="nav-item" *ngIf="accountType !== 'calculator'">
      <a routerLink="/dashboard"
         class="nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        <div class="nav-content">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
            <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
            <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
            <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
          </svg>
          <span *ngIf="sidebarExpanded">Dashboard</span>
        </div>
      </a>
    </li>

    <li class="nav-item" *ngIf="accountType !== 'calculator'">
      <a routerLink="/inventory"
         class="nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        <div class="nav-content">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 7.5L12 2.5L4 7.5M20 7.5V16.5L12 21.5M20 7.5L12 12.5M12 21.5L4 16.5V7.5M12 21.5V12.5M4 7.5L12 12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span *ngIf="sidebarExpanded">Inventory</span>
        </div>
      </a>
    </li>

    <li *ngIf="accountType !== 'calculator' && (userRole === 'Admin User' || userRole === 'Factory User')"  class="nav-item">
      <a routerLink="/manufacturing"
         class="nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        <div class="nav-content">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 21H16M12 3V5M12 5L19 9V15M12 5L5 9V15M19 15L12 19L5 15M19 15H5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span *ngIf="sidebarExpanded">Manufacturing</span>
        </div>
      </a>
    </li>


    <!-- cost calculator link -->
    <li *ngIf="accountType === 'calculator' || userRole === 'Admin User' || userRole === 'Financial User'"  class="nav-item">
      <a routerLink="/calc"
         class="nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        <div class="nav-content">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M8 6H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M8 10H10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M8 14H10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M8 18H10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M14 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M14 14H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M14 18H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span *ngIf="sidebarExpanded">Cost Calculator</span>
        </div>
      </a>
    </li>

    <li *ngIf="accountType !== 'calculator' && (userRole === 'Admin User' || userRole === 'Financial User')" class="nav-item">
      <a routerLink="/costing"
         class="nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        <div class="nav-content">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15V17M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.5 10C9.5 8.61929 10.6193 7.5 12 7.5C13.3807 7.5 14.5 8.61929 14.5 10C14.5 11.3807 13.3807 12.5 12 12.5C10.6193 12.5 9.5 11.3807 9.5 10Z" stroke="currentColor" stroke-width="2"/>
          </svg>
          <span *ngIf="sidebarExpanded">Budgeting</span>
        </div>
      </a>
    </li>



  </ul>



  <ul class="nav nav-pills nav-flush flex-column mt-1">
        <!-- business details section -->
        <li *ngIf="userRole === 'Admin User'" class="nav-item">
          <a routerLink="/business-details"
             class="nav-link"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{exact: true}">
            <div class="nav-content">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21H5M19 21H21M5 21H3M9 6.99998H10M9 11H10M9 15H10M14 6.99998H15M14 11H15M14 15H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span *ngIf="sidebarExpanded">Business Details</span>
            </div>
          </a>
        </li>


        <li *ngIf="userRole === 'Admin User'" class="nav-item">
          <a routerLink="/config"
             class="nav-link"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{exact: true}">
            <div class="nav-content">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.38 0 2.5 1.12 2.5 2.5S13.38 10 12 10s-2.5-1.12-2.5-2.5S10.62 5 12 5zm0 14.2c-2.67 0-5.33-1.33-8-4 2.67-2.67 5.33-4 8-4s5.33 1.33 8 4c-2.67 2.67-5.33 4-8 4z" fill="currentColor"/>
              </svg>
              <span  *ngIf="sidebarExpanded">Administration</span>
            </div>
          </a>
        </li>

    <li class="nav-item logout-item">
      <a (click)="logout()" class="nav-link">
        <div class="nav-content">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 17L21 12L16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 12H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span *ngIf="sidebarExpanded">Logout</span>
        </div>
      </a>
    </li>

  </ul>
</div>
